import { c as _c } from "react-compiler-runtime";
import { forwardRef } from 'react';
import { pickOverlayTriggerProps } from '../../utils/pickOverlayTriggerProps';
import { ButtonRoot } from './primitives';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Config-layer wrapper for `Button`. Exposes all visual and behavioral props
 * alongside a curated set of accessibility attributes, without the full button
 * HTML attribute surface.
 *
 * This component is part of Trellis's config API layer and covers the majority
 * of use cases. For advanced patterns, use the compositive API directly. If you
 * find yourself doing so, share your use case in #trellis-support — it directly
 * informs how we evolve the config layer.
 *
 * @see {@link ButtonRoot | Button}
 */
export const Button = /*#__PURE__*/forwardRef((props, ref) => {
  const $ = _c(29);
  const {
    children,
    variant,
    size,
    disabled,
    focusableWhenDisabled,
    fullWidth,
    type,
    icon,
    logo,
    startIcon,
    endIcon,
    startLogo,
    endLogo,
    onClick,
    onKeyDown,
    onKeyUp,
    id,
    ariaLabel,
    ariaLabelledby,
    ariaDescribedby,
    ariaDescription,
    ariaControls,
    ariaExpanded,
    dataTestId
  } = props;
  let t0;
  if ($[0] !== props) {
    t0 = pickOverlayTriggerProps(props);
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const triggerProps = t0;
  const t1 = id === null || id === void 0 ? void 0 : id.root;
  const t2 = ariaLabel === null || ariaLabel === void 0 ? void 0 : ariaLabel.root;
  const t3 = ariaLabelledby === null || ariaLabelledby === void 0 ? void 0 : ariaLabelledby.root;
  const t4 = ariaDescribedby === null || ariaDescribedby === void 0 ? void 0 : ariaDescribedby.root;
  const t5 = ariaDescription === null || ariaDescription === void 0 ? void 0 : ariaDescription.root;
  const t6 = ariaControls === null || ariaControls === void 0 ? void 0 : ariaControls.root;
  const t7 = ariaExpanded === null || ariaExpanded === void 0 ? void 0 : ariaExpanded.root;
  const t8 = dataTestId === null || dataTestId === void 0 ? void 0 : dataTestId.root;
  let t9;
  if ($[2] !== children || $[3] !== disabled || $[4] !== endIcon || $[5] !== endLogo || $[6] !== focusableWhenDisabled || $[7] !== fullWidth || $[8] !== icon || $[9] !== logo || $[10] !== onClick || $[11] !== onKeyDown || $[12] !== onKeyUp || $[13] !== ref || $[14] !== size || $[15] !== startIcon || $[16] !== startLogo || $[17] !== t1 || $[18] !== t2 || $[19] !== t3 || $[20] !== t4 || $[21] !== t5 || $[22] !== t6 || $[23] !== t7 || $[24] !== t8 || $[25] !== triggerProps || $[26] !== type || $[27] !== variant) {
    t9 = /*#__PURE__*/_jsx(ButtonRoot, Object.assign({
      ref: ref,
      variant: variant,
      size: size,
      disabled: disabled,
      focusableWhenDisabled: focusableWhenDisabled,
      fullWidth: fullWidth,
      type: type,
      icon: icon,
      logo: logo,
      startIcon: startIcon,
      endIcon: endIcon,
      startLogo: startLogo,
      endLogo: endLogo,
      onClick: onClick,
      onKeyDown: onKeyDown,
      onKeyUp: onKeyUp,
      id: t1,
      "aria-label": t2,
      "aria-labelledby": t3,
      "aria-describedby": t4,
      "aria-description": t5,
      "aria-controls": t6,
      "aria-expanded": t7,
      "data-test-id": t8
    }, triggerProps, {
      children: children
    }));
    $[2] = children;
    $[3] = disabled;
    $[4] = endIcon;
    $[5] = endLogo;
    $[6] = focusableWhenDisabled;
    $[7] = fullWidth;
    $[8] = icon;
    $[9] = logo;
    $[10] = onClick;
    $[11] = onKeyDown;
    $[12] = onKeyUp;
    $[13] = ref;
    $[14] = size;
    $[15] = startIcon;
    $[16] = startLogo;
    $[17] = t1;
    $[18] = t2;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
    $[25] = triggerProps;
    $[26] = type;
    $[27] = variant;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  return t9;
});
Button.displayName = 'Button';